// @flow

import React from 'react';
import type { ACFProps as ACFButtonProps } from '../../button';
import { ACFActionButton } from '../../actionButton';
import SubmitBar from './submitBar';

// Props also contains "rest props" which are the ACF
const ACFSubmitBar = (buttonProps: ACFButtonProps) => (
  <SubmitBar>
    {saving => <ACFActionButton {...buttonProps} loading={saving} />}
  </SubmitBar>
);

export default ACFSubmitBar;
